/* Hydrova energy-pattern quiz. 100% client-side: nothing is stored or sent.
   The only persistence is the URL hash, which carries the persona and nothing else. */
(function () {
  'use strict';

  var ORDER = ['AC', 'SR', 'FS', 'HAO']; /* also the final tie-break priority */
  var RESULTS = {
    AC: 'result-afternoon-crasher',
    SR: 'result-slow-recoverer',
    FS: 'result-foggy-starter',
    HAO: 'result-healthy-aging-optimizer'
  };

  var landing = document.getElementById('hyq-landing');
  var quiz = document.getElementById('hyq-quiz');
  var save = document.getElementById('hyq-save');
  var startBtn = document.getElementById('hyq-start');
  if (!landing || !quiz) { return; }

  var cards = quiz.querySelectorAll('.hyq-card');
  var step = 0;

  /* Show one question card and move the progress bar. */
  function showCard(i) {
    for (var n = 0; n < cards.length; n++) {
      if (n === i) { cards[n].classList.remove('hyq-hidden'); }
      else { cards[n].classList.add('hyq-hidden'); }
    }
    var bar = cards[i].querySelector('.hyq-progress span');
    if (bar) { bar.style.width = Math.round(((i + 1) / cards.length) * 100) + '%'; }
    step = i;
  }

  /* Add up every picked option's "PERSONA:points" pairs. */
  function tally() {
    var s = { AC: 0, SR: 0, FS: 0, HAO: 0 }, q3 = '', skeptic = '';
    var picked = quiz.querySelectorAll('.hyq-opt.is-picked');
    for (var i = 0; i < picked.length; i++) {
      var el = picked[i];
      var raw = el.getAttribute('data-score');
      if (raw) {
        var parts = raw.split(',');
        for (var p = 0; p < parts.length; p++) {
          var bit = parts[p].split(':');
          s[bit[0]] = s[bit[0]] + parseInt(bit[1], 10);
        }
      }
      if (el.getAttribute('data-q3')) { q3 = el.getAttribute('data-q3'); }
      if (el.getAttribute('data-skeptic')) { skeptic = el.getAttribute('data-skeptic'); }
    }
    return { s: s, q3: q3, skeptic: skeptic };
  }

  /* Highest total wins. Tie goes to the Q3 persona; still tied, AC > SR > FS > HAO. */
  function winner(t) {
    var best = -1, tied = [], i;
    for (i = 0; i < ORDER.length; i++) { if (t.s[ORDER[i]] > best) { best = t.s[ORDER[i]]; } }
    for (i = 0; i < ORDER.length; i++) { if (t.s[ORDER[i]] === best) { tied.push(ORDER[i]); } }
    if (tied.length === 1) { return tied[0]; }
    for (i = 0; i < tied.length; i++) { if (tied[i] === t.q3) { return t.q3; } }
    return tied[0]; /* tied was built in ORDER, so this is the priority fallback */
  }

  /* Reveal exactly one result block plus its one matching skeptic line. */
  function reveal(key, skeptic) {
    if (!RESULTS[key]) { return; }
    landing.classList.add('hyq-hidden');
    quiz.classList.add('hyq-hidden');
    var k, block;
    for (k in RESULTS) {
      block = document.getElementById(RESULTS[k]);
      if (!block) { continue; }
      if (k === key) { block.classList.remove('hyq-hidden'); }
      else { block.classList.add('hyq-hidden'); }
    }
    block = document.getElementById(RESULTS[key]);
    var lines = block.querySelectorAll('[data-skeptic-line]');
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-skeptic-line') === skeptic) { lines[i].classList.remove('hyq-hidden'); }
      else { lines[i].classList.add('hyq-hidden'); }
    }
    if (save) {
      save.classList.remove('hyq-hidden');
      /* the optional email form carries the pattern name only — never the answers */
      var tag = save.querySelector('[data-hyq-persona]');
      if (tag) { tag.value = RESULTS[key].replace('result-', ''); }
    }
  }

  function finish() {
    var t = tally();
    var key = winner(t);
    reveal(key, t.skeptic);
    location.hash = RESULTS[key]; /* reload restores the result; nothing else is kept */
  }

  function next() {
    if (step < cards.length - 1) { showCard(step + 1); } else { finish(); }
  }

  function back() {
    if (step > 0) { showCard(step - 1); }
    else { quiz.classList.add('hyq-hidden'); landing.classList.remove('hyq-hidden'); }
  }

  if (startBtn) {
    startBtn.addEventListener('click', function () {
      landing.classList.add('hyq-hidden');
      quiz.classList.remove('hyq-hidden');
      showCard(0);
    });
  }

  quiz.addEventListener('click', function (ev) {
    if (!ev.target.closest) { return; }
    var opt = ev.target.closest('.hyq-opt');
    if (opt) {
      var card = opt.closest('.hyq-card');
      if (card.getAttribute('data-multi') === '1') {
        opt.classList.toggle('is-picked'); /* Q6 is the only multi-select */
      } else {
        var sibs = card.querySelectorAll('.hyq-opt');
        for (var i = 0; i < sibs.length; i++) { sibs[i].classList.remove('is-picked'); }
        opt.classList.add('is-picked');
        next();
      }
      return;
    }
    if (ev.target.closest('.hyq-next')) { next(); return; }
    if (ev.target.closest('.hyq-back')) { back(); }
  });

  /* A returning visitor with #result-… in the URL gets their block back. */
  var hash = (window.location.hash || '').replace('#', '');
  for (var k in RESULTS) { if (RESULTS[k] === hash) { reveal(k, ''); } }
})();
